(function ($) {
    $(function () {

        var subnavs = $('.subnav.truncated');

        // If there is no truncated subnav, do nothing.
        if (subnavs.length === 0) {
            return;
        }

        subnavs.each(function () {

            var subnav = $(this);
            var subnavItems = subnav.find('li');
            var threshold = 6;

            // Apply a hidden class to all subnav items after the threshold.
            subnavItems.each(function () {
                var itemIndex = subnavItems.index(this); // Remember, index is zero-based.

                if (itemIndex > (threshold - 1)) {
                    $(this).addClass('hidden');
                }
            });

            // Append buttons to the subnav to show the hidden items.
            // Only append if the number of items exceeds the threshold.
            if (subnavItems.length > threshold) {
                var buttonShowMore = '<button type="button" class="cta-button subnav-show-more-button">Show more items</button>';
                var buttonShowLess = '<button type="button" class="cta-button subnav-show-less-button hidden">Show less items</button>';

                subnav.append(buttonShowMore);
                subnav.append(buttonShowLess);
            }

            // When the "show more" button is clicked, show the hidden items.
            subnav.find('.subnav-show-more-button').on('click', function () {
                subnavItems.removeClass('hidden');

                // Hide the "show more" button.
                $(this).addClass('hidden');

                // Show the "show less" button.
                subnav.find('.subnav-show-less-button').removeClass('hidden');
            });

            // When the "show less" button is clicked, hide the hidden items.
            subnav.find('.subnav-show-less-button').on('click', function () {
                subnavItems.each(function () {
                    var itemIndex = subnavItems.index(this); // Remember, index is zero-based.

                    if (itemIndex > (threshold - 1)) {
                        $(this).addClass('hidden');
                    }
                });

                // Hide the "show less" button.
                $(this).addClass('hidden');

                // Show the "show more" button.
                subnav.find('.subnav-show-more-button').removeClass('hidden');
            });
        });

    });
})(jQuery);